import { PRODUCT } from "@/constants";

const classNames = {
  avanti: {
    monthlySelectedCtaValueClassName: "text-dark-text-functional-subtle",
    ctaLabelClassName: "avanti-default-color",
  },

  staysure: {
    monthlySelectedCtaValueClassName: "text-dark-text-placeholder",
    ctaLabelClassName: "staysure-default-color",
  },
};

const brand: "staysure" | "avanti" =
  (PRODUCT as "staysure" | "avanti") ?? "staysure";

const fontColorClassNames = classNames[brand];

export default fontColorClassNames;
